import { UserProfileDetailsButtonActions } from '@/components/custom/userProfileDetails';
import { Loader, PanelInfo, ProfileDetailUserData } from '@/components/custom';
import { Separator } from '@/components/ui/separator.tsx';
import { Podcast } from 'lucide-react';
import { useUser } from '../hooks';

const BodyPage = () => {

	const { userId, isLoadingUserData, userData } = useUser();

	if (isLoadingUserData) {
		return (
			<div className='my-10'>
				<Loader className='my-10' />
			</div>
		);
	}

	if (!userData || !userId) {
		return (
			<PanelInfo
				title={'Cet utilisateur n\'existe pas'}
				description={
					<p className='flex space-x-1'>
						<span>
							Aucun utilisateur ne possède l'identifiant
						</span>
						<span className='font-semibold text-purple-600'>
							{userId}
						</span>
						<span>
							dans notre système.
						</span>
					</p>
				}
				className='py-10 md:py-26 border-none'
				icon={Podcast} />
		);
	}

	return (
		<div className={`flex flex-col gap-4`}>
			<ProfileDetailUserData userData={userData} />
			<Separator />
			<UserProfileDetailsButtonActions userData={userData} />
		</div>
	);

};

export default BodyPage;
